import { useSprintFetch } from "./useSprintFetch";

export const useUnauthorizedFetch = () => useSprintFetch({ isPublic: true });
